<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header></Header>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span>我的帳戶<span class="space">/</span>註冊新帳戶
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="create_user_box">
				<!-- <div class="sign_icon"></div> -->
				<h1>註冊新帳戶</h1>
				<h5>請使用您的常用電子郵件註冊新帳戶。</h5>
				<div class="input_box">
					<div class="item">
						<div class="title">電子郵件</div>
						<div class="e_input">
							<input class="in_txt" v-model="email" ref="email" type="text" maxlength="50" placeholder="請輸入電子郵件地址" />
						</div>
					</div>
					<div class="item">
						<div class="title">登錄密碼</div>
						<div class="e_input">
							<input class="in_txt" v-model="password" ref="password" type="password" maxlength="20" placeholder="請設置登錄密碼" />
						</div>
					</div>
					<div class="item">
						<div class="title">確認密碼</div>
						<div class="e_input">
							<input class="in_txt" v-model="re_password" ref="re_password" type="password" maxlength="20" placeholder="請再次輸入登錄密碼" />
						</div>
					</div>
					<div class="error_text" v-if="errStatus">{{errMessage}}</div>
				</div>
				<div class="btns">
					<el-button type="primary" :loading="btnLoading" style="width: 100%;" @click="signCheck()">{{btnTxt}}</el-button>
				</div>
				<div class="space_txt">
					<div class="txt">如果您已經註冊過賬戶，請在下面登錄</div>
				</div>
				<div class="other_box">
					<div class="pub_btn" @click="toLogin()">登錄</div>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		userSign,
	} from '@/api/index.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	export default {
		name: 'TW_UserSign',
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				fullscreenLoading: false, //loading状态
				language: 'tw',
				terminal: 'pc',
				email: '',
				password: '',
				re_password: '',
				errStatus: false,	//错误状态
				errMessage: '',	//错误提示
				timer: null,
				
				btnLoading: false,
				btnTxt: '註冊',
			}
		},
		created() {
			
		},
		beforeDestroy() {
			clearTimeout(this.timer)
		},
		methods: {
			// 注册
			async signCheck()
			{
				if(this.btnLoading)
				{
					return
				}
				
				if(this.email =='')
				{
					this.errStatus = true
					this.errMessage = '請輸入電子郵件地址'
					this.$refs.email.focus()
					return
				}
				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(this.email)) {
					this.errStatus = true
					this.errMessage = '電子郵件格式錯誤'
					this.$refs.email.focus()
					return
				}
					  
				if(this.password =='')
				{
					this.errStatus = true
					this.errMessage = '請輸入登錄密碼'
					this.$refs.password.focus()
					return
				}
				if(this.password.length < 6)
				{
					this.errStatus = true
					this.errMessage = '密碼長度不得小於6個字元'
					this.$refs.password.focus()
					return
				}
				
				if(this.re_password == '')
				{
					this.errStatus = true
					this.errMessage = '請再次輸入登錄密碼'
					this.$refs.re_password.focus()
					return
				}
				if(this.re_password != this.password)
				{
					this.errStatus = true
					this.errMessage = '兩次輸入密碼的不一致，請重新輸入'
					this.$refs.re_password.focus()
					return
				}
				
				this.errStatus = false
				this.errMessage = ''
				
				this.btnLoading = true
				this.btnTxt = "處理中，請稍候..."
				this.fullscreenLoading = true
				
				let params = {
					Language: this.language,
					Email: this.email,
					Password: this.password,
				}
				const { data: res } = await userSign(params)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.$message.success('恭喜您，帳號註冊成功');
					this.timer = setTimeout(() => {
						this.$router.push({
							path: '/tw/user/login'
						})
					}, 500)
				} else {
					this.btnLoading = false
					this.btnTxt = "註冊"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
			// 去登录
			toLogin()
			{
				this.$router.push({
					path: '/tw/user/login'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

		.el-button--primary {
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border: 0;
			border-radius: 8px;
			-webkit-transition: all .3s ease;
		}		
		.el-button--primary:focus {
			background-color: #008768;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
	}
</style>